/** Subtle animated film-grain overlay for cinematic texture. */
const Grain = () => <div className="grain" aria-hidden="true" />;

export default Grain;
